export const POWTOON_REQUESTED = 'powtoon_requested'
export const POWTOON_READY = 'powtoon_ready'
export const PLAYBACK_STARTED = 'playback_started'
export const PLAYBACK_COMPLETED = 'playback_completed'
export const MAX_VIEW_TIME = 'max_view_time'
export const LINKS = 'links'

export const LINK_CLICKED = 'clicked'
export const LINK_DISPLAYED = 'displayed'
